import { useState } from "react";
import {
  IconButton,
  Typography,
  Checkbox,
  Box,
  Card,
  List,
  Stack,
  ListItem,
  ListItemText,
  ListItemButton
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useSelector } from "react-redux";
import { English } from "../../../constant/EnglishFallback";
const TradesCard = ({ userTrades, handleToggle }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.ResumeBuilder || {};
  const {
    TEXT_USER_TRADES_INFO = English.ResumeBuilder.TEXT_USER_TRADES_INFO,
    TEXT_NO_TRADES_TO_PROFILE = English.ResumeBuilder.TEXT_NO_TRADES_TO_PROFILE
  } = LanguageData || {};
  return (
    <Card className="pagelist-content" sx={{ p: 2 }}>
      <Box sx={{ alignItems: "center",  justifyContent: "space-between",  display: "flex" }}  >
        <Typography variant="h6">{TEXT_USER_TRADES_INFO}</Typography>
        <IconButton color="primary" onClick={() => setIsExpanded((prev) => !prev)}>
          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      {isExpanded && (
        <List disablePadding>
          {userTrades.length > 0 ? (
            <Stack spacing={1} sx={{ pt: 1 }}>
              {userTrades.map((trade, index) => (
                <Card
                  key={index.toString()}
                  className="pagelist-content"
                  sx={{ marginTop: "0px", padding: 0, cursor: "pointer" }}>
                  <ListItem
                    key={index.toString()}
                    alignItems="flex-start"
                    sx={{ m: 0, p: 0 }}
                    secondaryAction={
                      <Checkbox
                        edge="end"
                        onChange={() => handleToggle(trade.id, "TradesCard")}
                        checked={trade.isSelected}
                      />
                    }>
                    <ListItemButton
                      onClick={() => handleToggle(trade.id, "TradesCard")}
                      alignItems="flex-start"
                      sx={{ m: 0 }}>
                      <ListItemText
                        sx={{ m: 0, alignItems: "flex-start" }}
                        primary={trade.tradeName}
                      />
                    </ListItemButton>
                  </ListItem>
                </Card>
              ))}
            </Stack>
          ) : (
            <Typography>{TEXT_NO_TRADES_TO_PROFILE}</Typography>
          )}
        </List>
      )}
    </Card>
  );
};

export default TradesCard;
